import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { eraseCookie } from "../CookiesHelpers";

const customerCookieKey = "customerid";
const jwtCookieKey = "accelerate.jwt";

export const add401Interceptor = (
  axiosInstance: AxiosInstance,
  setInvalidSession: (val: boolean) => void
) => {
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (has401(error)) {
        eraseCookie(jwtCookieKey);
        eraseCookie(customerCookieKey);
        setInvalidSession(true);
      }
      throw error;
    }
  );
};

const has401 = (error: AxiosError): boolean => {
  if (error.response?.status === 401) return true;
  // @ts-ignore
  const errors = error.response?.data?.errors;
  if (!errors) return false;
  if (errors instanceof Array) {
    return errors.some((err) => err.extensions?.http?.status === 401);
  }

  return false;
};

export const addGraphQLErrorInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      let errors = response?.data?.errors;
      if (errors) {
        // eslint-disable-next-line
        throw { response };
      } else {
        return response;
      }
    },
    (error: AxiosError) => {
      throw error;
    }
  );
};

const CancelToken = axios.CancelToken;

export function createCancelTokenHandler(requestName: string) {
  // initializing the cancel token handler object
  const cancelTokenHandler: any = {};

  // initializing the cancel token of the request
  const cancelTokenRequestHandler = {
    [requestName]: { cancelToken: undefined } as { [x: string]: any },
  };

  // associating the cancel token handler to the request name
  cancelTokenHandler[requestName] = {
    handleRequestCancellation: () => {
      // if a previous cancel token exists,
      // cancel the request
      if (cancelTokenRequestHandler[requestName].cancelToken) {
        cancelTokenRequestHandler[requestName].cancelToken.cancel(
          `${requestName} canceled`
        );
      }

      // creating a new cancel token
      cancelTokenRequestHandler[requestName].cancelToken = CancelToken.source();

      // returning the new cancel token
      return cancelTokenRequestHandler[requestName].cancelToken;
    },
  };

  return cancelTokenHandler;
}
